export default {"src":"https://fishbrain.com/_next/static/media/colorado.9131817c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};